import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";
import routes from "routes";
import { useMaterialUIController, setMiniSidenav } from "context";
import AlertMessage from "components/alert_message";
import Loader from "components/loader/loader";
import SignIn from "layouts/authentication/sign-in";
import history from "./helpers/history";
import PageNotFound from "layouts/not_found/not_found";
import Sidenav from "./examples/Sidenav";
import { useStoreState } from "easy-peasy";
import { getAuthUserIfNotExists } from "./api/api";
import { checkPermission } from "./helpers/checkPermission";
import DialogBox from "./components/dialog_box";
import { getInitialRoute } from "helpers/helpers";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, layout, sidenavColor, darkMode } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  const authUser = useStoreState((state) => state.authUser);

  const [state, setState] = useState({
    userChecked: authUser != null,
  });

  history.navigate = useNavigate();
  history.location = useLocation();

  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const userCheck = async () => {
    global.setLoading(true);
    const user = await getAuthUserIfNotExists();
    global.setLoading(false);
    setState({ ...state, userChecked: true });
    if (user && user?.id) {
      history.navigate(getInitialRoute(), { replace: true });
    }
  };
  useEffect(() => {
    userCheck();
  }, []);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (!checkPermission(route.permissions)) {
        return null;
      }
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" && authUser && (
        <Sidenav
          color={sidenavColor}
          brandName="DigiFlow"
          brand={"/images/logo.png"}
          routes={routes}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      {state.userChecked && (
        <Routes>
          {authUser && getRoutes(routes)}
          <Route path="/" element={<SignIn />} />
          <Route path="/not-found" element={<PageNotFound />} />
          <Route path="*" element={<Navigate to="/not-found" />} />
        </Routes>
      )}
      <AlertMessage />
      <Loader />
      <DialogBox />
    </ThemeProvider>
  );
}
